import React from "react";
import { ThemeToggle } from "@/components/theme-toggle";
import { LanguageSwitcher } from "@/components/language-switcher";

interface AuthWrapperProps {
  children: React.ReactNode;
}

export function AuthWrapper({ children }: AuthWrapperProps) {
  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-indigo-100 via-white to-cyan-100 dark:from-slate-950 dark:via-slate-900 dark:to-indigo-950 relative">
      {/* Theme and Language controls in top right */}
      <div className="absolute top-4 right-4 flex items-center gap-2 z-10">
        <LanguageSwitcher />
        <ThemeToggle />
      </div>
      <div className="min-h-screen w-full backdrop-blur-sm bg-white/20 dark:bg-black/30 flex items-center justify-center px-4">
        <div className="max-w-md w-full">
          <div className="bg-white/95 dark:bg-slate-900/90 backdrop-blur-md rounded-2xl shadow-2xl dark:shadow-2xl dark:shadow-indigo-500/10 border border-gray-200/50 dark:border-gray-800 p-8">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
